/**
 * Nurse Follow Up Visit Note — static options + empty form state.
 * Options mirror Eval & Orders → Nurse Visit Note screenshots.
 */

import { emptyNurseNotesCommonHeader } from "./nurseNotesCommonHeaderUtils";
import { emptyWoundAssessmentValues } from "./woundAssessmentContent";

export const LANGUAGE_OPTIONS = [
  "English",
  "Spanish",
  "Mandarin",
  "Cantonese",
  "Vietnamese",
  "Tagalog",
  "Korean",
  "Russian",
  "Arabic",
  "French",
  "Other",
];

export const DISCIPLINE_OPTIONS = ["RN", "PT", "OT", "ST", "MSW", "HHA"];

export const VISIT_TYPE_OPTIONS = ["Follow Up", "Recertification", "Other"];

export const SERVICE_LOCATION_OPTIONS = [
  "Patient Home",
  "Assisted Living Facility",
  "Skilled Nursing Facility",
  "Hospital",
  "Other",
];

export const REASON_FOCUS_OPTIONS = [
  "Disease Management",
  "Medication Management",
  "Wound Care",
  "Hospitalization F/U",
  "MD Visit F/U",
  "Change in Condition",
];

export const YES_NO_OPTIONS = ["Yes", "No"];

export const Y_N_OPTIONS = ["Y", "N"];

export const GI_GU_OPTIONS = ["WNL", "Abnormal"];

export const MEDS_COMPLIANCE_OPTIONS = ["Compliant", "Non-Comp"];

export const PROGRESS_STATUS_OPTIONS = ["Met", "Partial", "Not Met", "Ongoing"];

export const CAREGIVER_PARTICIPATION_OPTIONS = [
  "Active",
  "Limited",
  "Unable",
  "Not Applicable",
];

export const COMMUNICATION_METHOD_OPTIONS = [
  "Phone",
  "Fax",
  "Portal",
  "In Person",
  "Other",
];

export const toggleInList = (list, item) => {
  const arr = Array.isArray(list) ? list : [];
  return arr.includes(item) ? arr.filter((x) => x !== item) : [...arr, item];
};

const today = () => new Date().toISOString().slice(0, 10);

/** Full editable Nurse Visit Note payload (persisted as JSON on the dedicated row). */
export const emptyRnVisitPayload = () => ({
  billingCode: "",
  timeIn: "",
  timeOut: "",

  visitNumber: "",
  visitDate: "",

  commonHeader: emptyNurseNotesCommonHeader(),

  patientNameDisplay: "",
  dateOfBirth: "",
  mrn: "",
  address: "",
  phone: "",
  primaryLanguage: "",
  insurance: "",
  insuranceId: "",
  allergies: "",

  disciplines: ["RN"],
  visitType: "Follow Up",
  certPeriodFrom: "",
  certPeriodTo: "",
  serviceLocation: "Patient Home",
  providerRn: "",

  reasonFocus: [],
  reasonDescription: "",

  primaryDiagnosis1: "",
  primaryDiagnosis2: "",
  otherDiagnosis1: "",
  otherDiagnosis2: "",

  vitalsBp: "",
  vitalsHr: "",
  vitalsRr: "",
  vitalsTemp: "",
  vitalsSpo2: "",
  vitalsWeight: "",
  painLevel: null,

  alertOriented: "",
  skinWarmDry: "",
  lungsClear: "",
  edema: "",
  giGu: "",
  giGuDetails: "",

  systemCardiovascular: "",
  systemRespiratory: "",
  systemNeurological: "",
  systemIntegumentary: "",

  medsReviewed: "",
  medsChanges: "",
  medsCompliance: "",
  medsNotes: "",

  ...emptyWoundAssessmentValues(),

  fallRisk: "",
  homeHazards: "",
  assistiveDevicesText: "",

  goalsReviewed: false,
  progressStatus: "",
  progressComments: "",

  planUpdated: false,
  nextStepsPlan: "",

  caregiverPresent: false,
  caregiverParticipation: "",
  caregiverEducation: "",

  physicianNotified: "",
  physicianNotifiedName: "",
  communicationMethod: "",
  newOrdersReceived: "",
});

export { today as rnVisitToday };
